import { render } from "./PublicationVersionCard.vue.js?vue&type=template&id=149edeec&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationVersionCard.vue?vue&type=template&id=149edeec&scoped=true"
import script from "./PublicationVersionCard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationVersionCard.vue?vue&type=script&lang=js"
export * from "./PublicationVersionCard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationVersionCard.vue?vue&type=script&lang=js"

import "./PublicationVersionCard.vue.scss?vue&type=style&index=0&id=149edeec&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationVersionCard.vue?vue&type=style&index=0&id=149edeec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149edeec"],['__file',"src/Web/scripts/components/PublicationVersionCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "149edeec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('149edeec', __exports__)) {
    api.reload('149edeec', __exports__)
  }
  
  module.hot.accept("./PublicationVersionCard.vue.js?vue&type=template&id=149edeec&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationVersionCard.vue?vue&type=template&id=149edeec&scoped=true", () => {
    api.rerender('149edeec', render)
  })

}


export default __exports__